import React from 'react';
import Header from '../Header/Header';
import Login from '../Login/Login';
import Rides from '../Rides/Rides';

const Home = () => {
    return (
        <div>
            <Header></Header>
            <Rides></Rides>
            
        </div>
    );
};

export default Home;